module.exports = __webpack_public_path__ + "static/media/home-icon.c926f4ab.svg";